module.exports = __webpack_public_path__ + "img/qrland.8f5f57a6.webp";